import { render, staticRenderFns } from "./VentanaOperacionesAdjuntos.vue?vue&type=template&id=53f95b54"
import script from "./VentanaOperacionesAdjuntos.vue?vue&type=script&lang=js"
export * from "./VentanaOperacionesAdjuntos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports